// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview_bg_screen__dbTgG {
    background-color: #f1f2fb
}



.overview_tabs__ubkNs {
    /* background-color: white; */
    /* border-radius: 5px */
    margin: 0.7rem
}

.overview_disclaimer__6SU\\+B {
    font-style: italic
}

.overview_month__QfaVg {
    cursor: pointer;
    color: #1467b3;
    font-size: 20px;
    margin-right: 10px
}

.overview_kpi__M0usc {
    box-shadow: 0 4px 6px #cdd5eb;
    height: 110px;
    background-color: white;
    border: 1px solid #358696;
    border-radius: 5px;
    width: 100%
}


.overview_download_button__8dfG4 {
    color: #358696;
    background-color: transparent;
    border: none;
    
    
}


.overview_icons__ZkLCw {
    background-Color: #e7f5f8;
    border-Radius: 50%;
    padding: 10px;
    /* width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-Content: center;
    margin-Right: 10px; */
}

.overview_number_of_vehicles__3aTlN {
    color: black;
    font-Weight: 700;
    font-size: 20px;
    margin-Bottom: 5px;
}

.overview_vehicles_performance__dDY59 {
    color: gray;
    font-Weight: 500;
    font-Size: 14px;
    display: flex;
    align-Items: center;
}

.overview_cost_savings_tab__AFHSW {
    background-Color: white;
    border-radius: 10px;
    margin-Bottom: 20px;
    border: 1px solid #358696;
    display: flex;
    justify-Content: space-between;
    align-items: center;
    box-Shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.overview_potential_cost_savings__5AUat {
    color: #364e69;
    font-Weight: bold;
    margin-Bottom: 10px;
}

.overview_potential_cost_savingstext__MwU-e {
    color: #666;
    font-Size: 14px;
}

.overview_fuel_efficiency_tab__8Af2I {
    background-Color: white;
    border: 1px solid #358696;
    border-Radius: 5px;
    width: 100%;
}

.overview_fuel_efficiency_tabtext__td4fK {
    color: #364e69;
    margin-Bottom: 5px;
}

.overview_parameter_sel_tab__MaJFh {
    border: 1px solid #358696;
    border-Radius: 10px;
    width: 100%;
    background-Color: #f0f4f5;
}

.overview_parameter_distance__rH1sY {
    color: #364e69;
    font-Weight: bold;
    margin-Bottom: 5px;
}

.overview_button_apply__fheW6 {
    background-Color: #00005f;
    background-Image: linear-gradient(to left, #358696 0%, #358696 100%);
    color: white;
    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease-in-out;
    border: none;

}

.overview_vehicle_details__QLpyq {
    border-Radius: 10px;
    overflow: hidden;
    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.overview_table_icons__kAumv {
    font-Size: 10px;
    display: block;
}

.overview_table_titles__Rv5dW {
    color: white;
    background-Color: #358696;
    cursor: pointer;
}

.overview_vehicle_details_table__uWzRv {
    border-Radius: 10px;
    overflow: hidden;
}

.overview_vehicle_details_tableheader__tKIHX {
    color: white;
    background-Color: #358696;
}

.overview_tab_bar__Vq9kC {
    border-bottom: #358696 4px solid !important;
    border-radius: 2px !important;
    color: #358696 !important;
}

.overview_nav_bar_buttons__sW\\+Fy {
    background-color: transparent;
    border: none;
    font-weight: 800;
    font-size: 14px;
    color: gray
}

.overview_filter_dropdown__rjjMw {
    border-radius: 5px;
    border: none;
    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
    font-size: 13px;
    padding-top: 7px;
    padding-bottom: 7px;

}

/* check box */
.overview_checkboxWrapper_bus__OwUg6 {
    position: relative;
    padding-left: 24px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}

.overview_checkboxInput_bus__9\\+nrx {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #ccc;
    border-radius: 3px;
    background-color: #e6e6e6;
    position: relative;
    cursor: pointer;
    margin-right: 8px;
}

.overview_checkboxInput_bus__9\\+nrx:checked {
    display: flex;
    background-color: #358696;
    border-color: #358696;
}

.overview_checkboxInput_bus__9\\+nrx:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 0px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}

.overview_tabs_overview__u6CI5 {
    /* background-color: white; */
    /* border-radius: 5px */
    margin: 0.7rem
}

.overview_tab_overview__Srns7 {
    border-bottom: #358696 4px solid !important;
    border-radius: 2px !important;
    color: #358696 !important;
}

.overview_filter-tab-strip__0SIaM {
    background: #ffffff;
    border-bottom: 2px solid #E0E0E0;
    border-radius: 12px 12px 0 0;
    padding: 10px 20px;
    margin-bottom: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

}

.overview_filter-tab-strip__0SIaM .overview_tab-label__RsY5L {
    font-weight: 600;
    color: #358696;
    font-size: 15px;
}

.overview_row__XdJA3.overview_mb-3__bB3ok,
.overview_row__XdJA3.overview_mb-3__bB3ok * {
  color: black !important;
}





.overview_MS_button__j0kcO {}

.overview_MS_button__j0kcO:focus {
    background-color: #83a4cf !important;
}

.overview_MS_button__j0kcO:hover {
    background-color: #83a4cf !important;
}

.overview_ms_btn__n3wVo.overview_btn__XQx7c:focus,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:focus-visible,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:focus-within,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:hover,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:visited,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:active,
.overview_ms_btn__n3wVo.overview_btn__XQx7c:target {
    color: #fff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.overview_ms_btn__n3wVo.overview_btn__XQx7c {
    color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.overview_ms_btn__n3wVo.overview_btn__XQx7c.overview_active__PeEem {
    color: #ffffff !important;
    border-color: #83a4cf !important;
    background-color: #83a4cf !important;
}

.overview_cursor_pointer__uCM6h {
    cursor: pointer;
}


.overview_custom-tooltip__XFdj4 .overview_tooltip-inner__5irTh {
    background-color: white !important;
    color: rgb(34, 32, 32) !important;
    border: 1px solid #ccc;
    font-size: 0.8rem;
    padding: 4px
        /* optional */
}

.overview_custom-tooltip__XFdj4.overview_bs-tooltip-top__Oe2fe .overview_tooltip-arrow__eg-\\+I::before,
.overview_custom-tooltip__XFdj4.overview_bs-tooltip-bottom__lo1\\+m .overview_tooltip-arrow__eg-\\+I::before,
.overview_custom-tooltip__XFdj4.overview_bs-tooltip-left__wKLiK .overview_tooltip-arrow__eg-\\+I::before,
.overview_custom-tooltip__XFdj4.overview_bs-tooltip-right__5pYfu .overview_tooltip-arrow__eg-\\+I::before {
    border-top-color: white !important;
    border-bottom-color: white !important;
    border-left-color: white !important;
    border-right-color: white !important;
}


.overview_ms_btn_close__lnriC.overview_btn__XQx7c:focus,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:focus-visible,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:focus-within,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:hover,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:visited,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:active,
.overview_ms_btn_close__lnriC.overview_btn__XQx7c:target {
    color: #fff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.overview_ms_btn_close__lnriC.overview_btn__XQx7c {
    color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.overview_ms_btn_close__lnriC.overview_btn__XQx7c.overview_active__PeEem {
    color: #ffffff !important;
    border-color: #83a4cf !important;
    background-color: #83a4cf !important;
}

.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c {
    color: #ffffff !important;
    transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c:active {
    transform: scale(0.99);
    /* press effect */
    background-color: #5f85b3 !important;
    border-color: #5f85b3 !important;
}

.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_active__PeEem {
    color: #ffffff !important;
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}

.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it {
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
}



.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:hover,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:focus,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:focus-visible,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:focus-within,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:visited,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_primary__7m9it:target {
    color: #ffffff !important;
    background-color: #6f96c0 !important;
    border-color: #6f96c0 !important;
}


.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx {
    background-color: #a2a4a7 !important;
    border-color: #8c8d8d !important;
}

.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:hover,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:focus,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:focus-visible,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:focus-within,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:visited,
.overview_ms_btn_solid_Bus__BTfNl.overview_btn__XQx7c.overview_secondary__MCwGx:target {
    color: #ffffff !important;
    background-color: #878889 !important;
    border-color: #717272 !important;
}

/* input[type="range"]::-webkit-slider-runnable-track {
    pointer-events: none;
} */
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/Overview_Tab_ace/overview.module.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;;;AAIA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;;AAGA;IACI,cAAc;IACd,6BAA6B;IAC7B,YAAY;;;AAGhB;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb;;;;;yBAKqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,oEAAoE;IACpE,YAAY;IACZ,wCAAwC;IACxC,sCAAsC;IACtC,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;;AAE7C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;;EAEE,uBAAuB;AACzB;;;;;;AAMA,4BAAY;;AAEZ;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;QACP,aAAa;AACrB;;AAEA;;;;IAII,kCAAkC;IAClC,qCAAqC;IACrC,mCAAmC;IACnC,oCAAoC;AACxC;;;AAGA;;;;;;;IAOI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,mFAAmF;AACvF;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;;;AAIA;;;;;;IAMI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;;AAGA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;;;;;IAMI,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;GAEG","sourcesContent":[".bg_screen {\n    background-color: #f1f2fb\n}\n\n\n\n.tabs {\n    /* background-color: white; */\n    /* border-radius: 5px */\n    margin: 0.7rem\n}\n\n.disclaimer {\n    font-style: italic\n}\n\n.month {\n    cursor: pointer;\n    color: #1467b3;\n    font-size: 20px;\n    margin-right: 10px\n}\n\n.kpi {\n    box-shadow: 0 4px 6px #cdd5eb;\n    height: 110px;\n    background-color: white;\n    border: 1px solid #358696;\n    border-radius: 5px;\n    width: 100%\n}\n\n\n.download_button {\n    color: #358696;\n    background-color: transparent;\n    border: none;\n    \n    \n}\n\n\n.icons {\n    background-Color: #e7f5f8;\n    border-Radius: 50%;\n    padding: 10px;\n    /* width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-Content: center;\n    margin-Right: 10px; */\n}\n\n.number_of_vehicles {\n    color: black;\n    font-Weight: 700;\n    font-size: 20px;\n    margin-Bottom: 5px;\n}\n\n.vehicles_performance {\n    color: gray;\n    font-Weight: 500;\n    font-Size: 14px;\n    display: flex;\n    align-Items: center;\n}\n\n.cost_savings_tab {\n    background-Color: white;\n    border-radius: 10px;\n    margin-Bottom: 20px;\n    border: 1px solid #358696;\n    display: flex;\n    justify-Content: space-between;\n    align-items: center;\n    box-Shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.potential_cost_savings {\n    color: #364e69;\n    font-Weight: bold;\n    margin-Bottom: 10px;\n}\n\n.potential_cost_savingstext {\n    color: #666;\n    font-Size: 14px;\n}\n\n.fuel_efficiency_tab {\n    background-Color: white;\n    border: 1px solid #358696;\n    border-Radius: 5px;\n    width: 100%;\n}\n\n.fuel_efficiency_tabtext {\n    color: #364e69;\n    margin-Bottom: 5px;\n}\n\n.parameter_sel_tab {\n    border: 1px solid #358696;\n    border-Radius: 10px;\n    width: 100%;\n    background-Color: #f0f4f5;\n}\n\n.parameter_distance {\n    color: #364e69;\n    font-Weight: bold;\n    margin-Bottom: 5px;\n}\n\n.button_apply {\n    background-Color: #00005f;\n    background-Image: linear-gradient(to left, #358696 0%, #358696 100%);\n    color: white;\n    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    transition: transform 0.2s ease-in-out;\n    border: none;\n\n}\n\n.vehicle_details {\n    border-Radius: 10px;\n    overflow: hidden;\n    box-Shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.table_icons {\n    font-Size: 10px;\n    display: block;\n}\n\n.table_titles {\n    color: white;\n    background-Color: #358696;\n    cursor: pointer;\n}\n\n.vehicle_details_table {\n    border-Radius: 10px;\n    overflow: hidden;\n}\n\n.vehicle_details_tableheader {\n    color: white;\n    background-Color: #358696;\n}\n\n.tab_bar {\n    border-bottom: #358696 4px solid !important;\n    border-radius: 2px !important;\n    color: #358696 !important;\n}\n\n.nav_bar_buttons {\n    background-color: transparent;\n    border: none;\n    font-weight: 800;\n    font-size: 14px;\n    color: gray\n}\n\n.filter_dropdown {\n    border-radius: 5px;\n    border: none;\n    box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n    font-size: 13px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n\n}\n\n/* check box */\n.checkboxWrapper_bus {\n    position: relative;\n    padding-left: 24px;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n}\n\n.checkboxInput_bus {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #ccc;\n    border-radius: 3px;\n    background-color: #e6e6e6;\n    position: relative;\n    cursor: pointer;\n    margin-right: 8px;\n}\n\n.checkboxInput_bus:checked {\n    display: flex;\n    background-color: #358696;\n    border-color: #358696;\n}\n\n.checkboxInput_bus:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 4px;\n    top: 0px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n}\n\n.tabs_overview {\n    /* background-color: white; */\n    /* border-radius: 5px */\n    margin: 0.7rem\n}\n\n.tab_overview {\n    border-bottom: #358696 4px solid !important;\n    border-radius: 2px !important;\n    color: #358696 !important;\n}\n\n.filter-tab-strip {\n    background: #ffffff;\n    border-bottom: 2px solid #E0E0E0;\n    border-radius: 12px 12px 0 0;\n    padding: 10px 20px;\n    margin-bottom: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n\n}\n\n.filter-tab-strip .tab-label {\n    font-weight: 600;\n    color: #358696;\n    font-size: 15px;\n}\n\n.row.mb-3,\n.row.mb-3 * {\n  color: black !important;\n}\n\n\n\n\n\n.MS_button {}\n\n.MS_button:focus {\n    background-color: #83a4cf !important;\n}\n\n.MS_button:hover {\n    background-color: #83a4cf !important;\n}\n\n.ms_btn.btn:focus,\n.ms_btn.btn:focus-visible,\n.ms_btn.btn:focus-within,\n.ms_btn.btn:hover,\n.ms_btn.btn:visited,\n.ms_btn.btn:active,\n.ms_btn.btn:target {\n    color: #fff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn.btn {\n    color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn.btn.active {\n    color: #ffffff !important;\n    border-color: #83a4cf !important;\n    background-color: #83a4cf !important;\n}\n\n.cursor_pointer {\n    cursor: pointer;\n}\n\n\n.custom-tooltip .tooltip-inner {\n    background-color: white !important;\n    color: rgb(34, 32, 32) !important;\n    border: 1px solid #ccc;\n    font-size: 0.8rem;\n    padding: 4px\n        /* optional */\n}\n\n.custom-tooltip.bs-tooltip-top .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-bottom .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-left .tooltip-arrow::before,\n.custom-tooltip.bs-tooltip-right .tooltip-arrow::before {\n    border-top-color: white !important;\n    border-bottom-color: white !important;\n    border-left-color: white !important;\n    border-right-color: white !important;\n}\n\n\n.ms_btn_close.btn:focus,\n.ms_btn_close.btn:focus-visible,\n.ms_btn_close.btn:focus-within,\n.ms_btn_close.btn:hover,\n.ms_btn_close.btn:visited,\n.ms_btn_close.btn:active,\n.ms_btn_close.btn:target {\n    color: #fff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_close.btn {\n    color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_close.btn.active {\n    color: #ffffff !important;\n    border-color: #83a4cf !important;\n    background-color: #83a4cf !important;\n}\n\n.ms_btn_solid_Bus.btn {\n    color: #ffffff !important;\n    transition: transform 0.1s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.ms_btn_solid_Bus.btn:active {\n    transform: scale(0.99);\n    /* press effect */\n    background-color: #5f85b3 !important;\n    border-color: #5f85b3 !important;\n}\n\n.ms_btn_solid_Bus.btn.active {\n    color: #ffffff !important;\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n.ms_btn_solid_Bus.btn.primary {\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n}\n\n\n\n.ms_btn_solid_Bus.btn.primary:hover,\n.ms_btn_solid_Bus.btn.primary:focus,\n.ms_btn_solid_Bus.btn.primary:focus-visible,\n.ms_btn_solid_Bus.btn.primary:focus-within,\n.ms_btn_solid_Bus.btn.primary:visited,\n.ms_btn_solid_Bus.btn.primary:target {\n    color: #ffffff !important;\n    background-color: #6f96c0 !important;\n    border-color: #6f96c0 !important;\n}\n\n\n.ms_btn_solid_Bus.btn.secondary {\n    background-color: #a2a4a7 !important;\n    border-color: #8c8d8d !important;\n}\n\n.ms_btn_solid_Bus.btn.secondary:hover,\n.ms_btn_solid_Bus.btn.secondary:focus,\n.ms_btn_solid_Bus.btn.secondary:focus-visible,\n.ms_btn_solid_Bus.btn.secondary:focus-within,\n.ms_btn_solid_Bus.btn.secondary:visited,\n.ms_btn_solid_Bus.btn.secondary:target {\n    color: #ffffff !important;\n    background-color: #878889 !important;\n    border-color: #717272 !important;\n}\n\n/* input[type=\"range\"]::-webkit-slider-runnable-track {\n    pointer-events: none;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg_screen": `overview_bg_screen__dbTgG`,
	"tabs": `overview_tabs__ubkNs`,
	"disclaimer": `overview_disclaimer__6SU+B`,
	"month": `overview_month__QfaVg`,
	"kpi": `overview_kpi__M0usc`,
	"download_button": `overview_download_button__8dfG4`,
	"icons": `overview_icons__ZkLCw`,
	"number_of_vehicles": `overview_number_of_vehicles__3aTlN`,
	"vehicles_performance": `overview_vehicles_performance__dDY59`,
	"cost_savings_tab": `overview_cost_savings_tab__AFHSW`,
	"potential_cost_savings": `overview_potential_cost_savings__5AUat`,
	"potential_cost_savingstext": `overview_potential_cost_savingstext__MwU-e`,
	"fuel_efficiency_tab": `overview_fuel_efficiency_tab__8Af2I`,
	"fuel_efficiency_tabtext": `overview_fuel_efficiency_tabtext__td4fK`,
	"parameter_sel_tab": `overview_parameter_sel_tab__MaJFh`,
	"parameter_distance": `overview_parameter_distance__rH1sY`,
	"button_apply": `overview_button_apply__fheW6`,
	"vehicle_details": `overview_vehicle_details__QLpyq`,
	"table_icons": `overview_table_icons__kAumv`,
	"table_titles": `overview_table_titles__Rv5dW`,
	"vehicle_details_table": `overview_vehicle_details_table__uWzRv`,
	"vehicle_details_tableheader": `overview_vehicle_details_tableheader__tKIHX`,
	"tab_bar": `overview_tab_bar__Vq9kC`,
	"nav_bar_buttons": `overview_nav_bar_buttons__sW+Fy`,
	"filter_dropdown": `overview_filter_dropdown__rjjMw`,
	"checkboxWrapper_bus": `overview_checkboxWrapper_bus__OwUg6`,
	"checkboxInput_bus": `overview_checkboxInput_bus__9+nrx`,
	"tabs_overview": `overview_tabs_overview__u6CI5`,
	"tab_overview": `overview_tab_overview__Srns7`,
	"filter-tab-strip": `overview_filter-tab-strip__0SIaM`,
	"tab-label": `overview_tab-label__RsY5L`,
	"row": `overview_row__XdJA3`,
	"mb-3": `overview_mb-3__bB3ok`,
	"MS_button": `overview_MS_button__j0kcO`,
	"ms_btn": `overview_ms_btn__n3wVo`,
	"btn": `overview_btn__XQx7c`,
	"active": `overview_active__PeEem`,
	"cursor_pointer": `overview_cursor_pointer__uCM6h`,
	"custom-tooltip": `overview_custom-tooltip__XFdj4`,
	"tooltip-inner": `overview_tooltip-inner__5irTh`,
	"bs-tooltip-top": `overview_bs-tooltip-top__Oe2fe`,
	"tooltip-arrow": `overview_tooltip-arrow__eg-+I`,
	"bs-tooltip-bottom": `overview_bs-tooltip-bottom__lo1+m`,
	"bs-tooltip-left": `overview_bs-tooltip-left__wKLiK`,
	"bs-tooltip-right": `overview_bs-tooltip-right__5pYfu`,
	"ms_btn_close": `overview_ms_btn_close__lnriC`,
	"ms_btn_solid_Bus": `overview_ms_btn_solid_Bus__BTfNl`,
	"primary": `overview_primary__7m9it`,
	"secondary": `overview_secondary__MCwGx`
};
export default ___CSS_LOADER_EXPORT___;
